import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Inter', sans-serif;
    }


    html,
    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: #f7f9ff;
        overflow-x: hidden;
        width: 100%;

        /*
          antd trae 'body, html { height: 100% }'. Con el overflow-x: hidden de
          arriba, html propaga su overflow al viewport y el que acaba scrolleando
          es <body>, no la ventana: window.scrollY se queda en 0 para siempre.
          Nadie lo notaba (la página scrollea igual) pero rompía en silencio el
          botón de subir, el scrollTo(0,0) al cambiar de página y —ahora— el
          amanecer del hero, que lee el scroll. Con height auto vuelve a mandar
          el viewport.
        */
        height: auto;
    }

    section {
        max-width: 100vw;
    }

    a:hover {
        color: #111c44;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #101a3a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Space Grotesk', 'Inter', sans-serif;
        color: #111c44;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }

        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    h1,
    h2 {
        font-family: 'Space Grotesk', 'Inter', sans-serif;
        font-weight: 650;
        letter-spacing: -0.04em;
        line-height: 1.02;
        text-wrap: balance;
    }

    p {
        color: #111c44;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 650;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #101a3a;

        :hover {
            color: #101a3a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
